import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const AffiliateProfile = lazy(() => import('@pages/affiliate/AffiliateProfile'));

export const AffiliateProfileRoutes: RouteObject[] = [
  {
    path: '/affiliate-profile',
    element: (
      <React.Suspense>
        <AffiliateProfile />
      </React.Suspense>
    ),
  },
]; 